import React, { useEffect, useState } from "react";
import {
    Box,
    Container,
    Typography,
    useMediaQuery,
    Card,
    CardContent,
    Paper,
    Button,
} from "@material-ui/core";
import Header from "../../component/Header/Header";
import { useTranslation } from "react-i18next";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import "./LoginPage.scss";
import clo_afterLogin from "../../images/clo_afterLogin.jpg";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
        // backgroundImage: `url(${clo_login})`,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function AfterLoginCLO() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    return (
        <Button
            className="buttons"
            component={Link}
            to="/main"
            variant="contained"
            style={{
                backgroundImage: `url(${clo_afterLogin})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                height: "100vh",
                width: "100%",
            }}
        ></Button>
    );
}
export default AfterLoginCLO;
